export const WELCOME_AFTER_LOGIN_KEY = 'nimsi_clinic_welcome_pending';
const LEGACY_WELCOME_AFTER_LOGIN_KEY = 'dem_clinic_welcome_pending';

export function markWelcomeAfterLogin() {
  try {
    sessionStorage.setItem(WELCOME_AFTER_LOGIN_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function consumeWelcomePending() {
  try {
    if (sessionStorage.getItem(WELCOME_AFTER_LOGIN_KEY) === '1') {
      sessionStorage.removeItem(WELCOME_AFTER_LOGIN_KEY);
      return true;
    }
    if (sessionStorage.getItem(LEGACY_WELCOME_AFTER_LOGIN_KEY) === '1') {
      sessionStorage.removeItem(LEGACY_WELCOME_AFTER_LOGIN_KEY);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}
